import { internalSelectedCustomerIdStorage } from "features/auth/AuthUtils";
import { InternalSidebar } from "features/internal/InternalSidebar";
import { useInternalCustomerRetrieve } from "gen/endpoints/internal/internal";
import { useEffect } from "react";
import { Outlet, useMatches } from "react-router-dom";
import { QueryBoundary } from "shared/api/QueryBoundary";
import { LoadingState } from "shared/components/empty/LoadingState";
import NotFoundPage from "shared/components/empty/NotFoundPage";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { AppConfig } from "shared/config/AppConfig";
import { useEffectOnce } from "shared/hooks/useEffectOnce";
import { getRouteHandle } from "shared/navigation/RouteHandle";
import { useHasPermission } from "shared/utils/PermissionUtils";

const InternalLayout: React.FC = () => {
  const hasServiceAccess = useHasPermission("service");
  const matches = useMatches();

  useEffectOnce(() => {
    if (AppConfig.subdomains?.isSubdomain) {
      const redirectUrl = new URL(
        location.pathname,
        AppConfig.subdomains.authRootUrl.toString(),
      );
      window.location.replace(redirectUrl);
    }
  });

  const { data: internalCustomerData } = useInternalCustomerRetrieve();

  useEffect(() => {
    if (internalCustomerData) {
      internalSelectedCustomerIdStorage.set(internalCustomerData.id!);
    }
  }, [internalCustomerData]);

  if (!hasServiceAccess) {
    return <NotFoundPage />;
  }

  if (AppConfig.subdomains?.isSubdomain) {
    return (
      <PageContainer>
        <PageContent isFullHeight={true}>
          <PageBody>
            <LoadingState />
          </PageBody>
        </PageContent>
      </PageContainer>
    );
  }

  const showSidebar = matches.some(
    (match) => getRouteHandle(match)?.showSidebar,
  );
  return (
    <PageContainer>
      <InternalSidebar showSidebar={showSidebar} />
      <QueryBoundary isPage={true}>
        <Outlet />
      </QueryBoundary>
    </PageContainer>
  );
};

export default InternalLayout;
